/**
 * Iter98: Helper für Web-Push Subscription via Service Worker.
 */
import { apiClient } from "@/lib/apiClient";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

async function getRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  return await navigator.serviceWorker.register("/sw.js");
}

export async function isPushSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getCurrentPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function getCurrentPushSubscription() {
  if (!(await isPushSupported())) return null;
  const reg = await getRegistration();
  if (!reg) return null;
  return await reg.pushManager.getSubscription();
}

export async function enableWebPush() {
  if (!(await isPushSupported())) {
    throw new Error("Browser unterstützt keine Push-Notifications");
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Push-Berechtigung wurde abgelehnt");
  }

  const reg = await getRegistration();
  if (!reg) throw new Error("Service-Worker konnte nicht registriert werden");

  // Public Key vom Backend holen
  const { data } = await apiClient.get("/push/vapid-public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.public_key);

  // Subscribe
  const subscription = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });

  // Backend speichern
  const json = subscription.toJSON();
  await apiClient.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
    user_agent: navigator.userAgent,
  });

  return subscription;
}

export async function disableWebPush() {
  const sub = await getCurrentPushSubscription();
  if (!sub) return;
  try {
    await apiClient.post(`/push/unsubscribe?endpoint=${encodeURIComponent(sub.endpoint)}`);
  } catch (e) {
    console.warn("Backend unsubscribe failed", e);
  }
  await sub.unsubscribe();
}

export async function sendTestPush() {
  const r = await apiClient.post("/push/test");
  return r.data;
}
